import get from 'lodash/get';
import set from 'lodash/set';

// 横跨各patent的缓存
const appCache = {
    cache: {},
};

appCache.set = function(keyPath, value) {
    set(this.cache, keyPath, value);
};

appCache.get = function(keyPath) {
    return get(this.cache, keyPath);
};

appCache.clear = function(keyPath) {
    set(this.cache, keyPath, undefined);
};

appCache.update = function(keyPath, value) {
    if (!get(this.cache, `['patent'][${keyPath}]`, null)) return;
    this.cache['patent'][keyPath] = Object.assign(this.cache['patent'][keyPath], value);
};

export default appCache;
